import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "primereact/multiselect";
import DatePicker from "react-multi-date-picker";
import { useUniversalHelpdesk } from "../../../Hooks/Features/HelpDesk/useUniversalHelpdesk";
import { AgGridReact } from "@ag-grid-community/react";
import CreateTicket from "../../../components/HelpDesk/CreateTicket";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { SkeletonDataTable } from "../../../components/Loader/Loader";
import { Dialog } from "primereact/dialog";
import CommonImage from "../../../components/CommonCompo/CommonImage/CommonImage";
import { useCommon } from "../../../Hooks/Common/useCommon";
import { dateConvert } from "../../../utils/Helper";
import RequestTypeMapping from "../../../components/HelpDesk/RequestTypeMapping";
import { useRequestTypeMapping } from "../../../Hooks/Features/HelpDesk/useRequestTypeMapping";
import Pagination from "../../../components/CommonCompo/Pagination/pagination.js";
import _ from "underscore";
import { useTheme } from "../../../context/ThemeContext";
import { DateObject } from 'react-multi-date-picker';
import Logwork from "../../../components/Dashboard/WorklogCalendar/Logwork.jsx";
import { useCalender } from "../../../Hooks/Features/Dashboard/useCalender.js";
import { Dropdown } from "primereact/dropdown";
import UniHelpdeskCharts from "../../../components/UniversalHelpdesk/UniHelpdeskCharts.jsx";

function UniversalHelpdesk() {
    const { theme } = useTheme();
    const { handleDateSelected, filterValue, setFilterValue, tableData, calendarDate, getTimesheetCalendarSummary } = useCalender()
    const { filters, setFilters, statuses, columnDefs, data, setShowPopup, showPopup, options, editData, getRequestData, setEditData, loader, selectedData, setSelectedData, tagRef, getExcelDownload, historyPopup, setHistoryPopup, commentPopup, setCommentPopup, saveComment, chatRef, pagination, setPagination, statusCount, updateTicketCommentsRead, showTimesheet, setShowTimesheet, dynamicField, handleDropdownChange, tab, chart, setChart } = useUniversalHelpdesk();
    const { checkPermission } = useCommon()
    const { mappingList, getRequestTypeUserMappingData } = useRequestTypeMapping({});

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "universal_helpdesk_tab"}'>
                <div className="row sk-header-row">
                    <div className="row col-md-10">
                        <div className="col-md-2">
                            <Dropdown
                                value={filters?.location || null}
                                options={options?.locations}
                                onChange={e => { if (!e?.value) { getRequestData("location"); } setFilters((prev) => ({ ...prev, location: e.value, isChange: true })); }}
                                placeholder="Location"
                                className="sk-multiselect w-100"
                                panelClassName="sk-multiselect-panel"
                                optionLabel="location"
                                showClear
                                filter filterInputAutoFocus
                                onHide={() => filters?.isChange && getRequestData()}
                            />
                        </div>
                        <div className="col-md-2">
                            <Dropdown
                                value={dynamicField[0]?.[0] || null}
                                options={options?.requestType}
                                onChange={(e) => { if (e.value === undefined) { getRequestData("type"); getRequestTypeUserMappingData([]) }; handleDropdownChange(e.value, 0) }}
                                placeholder="Request Type"
                                className="sk-multiselect w-100"
                                panelClassName="sk-multiselect-panel"
                                optionLabel="request_type_name"
                                showClear
                                filter filterInputAutoFocus
                                onHide={() => {
                                    if (filters?.isChange) {
                                        getRequestData();
                                        getRequestTypeUserMappingData(dynamicField[0] || []);
                                    }
                                }}
                            />
                        </div>
                        {dynamicField.map((_, index) => {
                            const currentLevelSelections = dynamicField[index] || [];
                            if (currentLevelSelections.length === 0) return null;
                            const parentIds = currentLevelSelections.map(item => item.request_type_id);
                            const combinedChildCategories = (options?.allType || []).filter((type) =>
                                parentIds.includes(type.parent_request_type_id)
                            );
                            if (combinedChildCategories.length === 0) return null;
                            const nextIndex = index + 1;
                            return (
                                <div className="col-md-2" key={`nested_layer_${nextIndex}`}>
                                    <Dropdown
                                        value={dynamicField[nextIndex]?.[0] || null}
                                        options={combinedChildCategories || []}
                                        onChange={(e) => handleDropdownChange(e.value, nextIndex)}
                                        placeholder="Select Sub-Category"
                                        className="sk-multiselect w-100"
                                        panelClassName="sk-multiselect-panel"
                                        optionLabel="request_type_name"
                                        showClear
                                        onHide={() => {
                                            if (filters?.isChange) {
                                                getRequestData();
                                                getRequestTypeUserMappingData(dynamicField[nextIndex] || []);
                                            }
                                        }}
                                    />
                                </div>
                            );
                        })}
                        <div className="col-md-2">
                            <MultiSelect
                                value={filters?.subtype || []}
                                options={options?.filtersubRequestType || []}
                                onChange={(e) => setFilters((prev) => ({ ...prev, subtype: e.value, isChange: true }))}
                                disabled={!options?.filtersubRequestType?.length}
                                placeholder="Sub Request Type"
                                className="sk-multiselect w-100"
                                panelClassName="sk-multiselect-panel"
                                optionLabel="request_sub_type_name"
                                onHide={() => { if (filters?.isChange) getRequestData(); }}
                                panelHeaderTemplate={(optionsTemplate) =>
                                    PanelHeaderTemplate(optionsTemplate, 'subtype', filters?.subtype, () => {
                                        setFilters((prevState) => ({
                                            ...prevState,
                                            subtype: [],
                                            isChange: true
                                        }));
                                    })
                                }
                            />
                        </div>
                        <div className="col-md-2">
                            <MultiSelect
                                value={filters.closeBy}
                                options={_.uniq(mappingList, "user_code")}
                                onChange={e => setFilters((prev) => ({ ...prev, closeBy: e.value, isChange: true }))}
                                placeholder="Close By"
                                optionLabel="user_display_name"
                                className="sk-multiselect"
                                panelClassName="sk-multiselect-panel"
                                onHide={() => filters?.isChange && getRequestData()}
                                panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'closeBy', filters?.closeBy, () => setFilters((prevState) => ({
                                    ...prevState,
                                    closeBy: [],
                                    isChange: true
                                })))} />
                        </div>
                        <div className="col-md-2 d-flex gap-2">
                            <DatePicker
                                value={filters.date}
                                placeholder="Select Date"
                                range
                                rangeHover
                                onChange={e => setFilters({ ...filters, date: e, isChange: true })}
                                onClose={() => { if (filters?.isChange) { getRequestData() } }}
                            />
                        </div>
                    </div>
                    <div className="col-md-2 p-0  d-flex gap-2 justify-content-end col-12 ms-auto">
                        <div className="d-flex gap-1">
                            <button className="sk-btn sk-btn-primary" onClick={() => { getRequestData(); if (tab === "chart") { } }}>
                                <i className="icon-refresh-outline" />
                            </button>
                            {tab !== "chart" &&
                                <div>
                                    <button className="sk-btn sk-btn-primary" onClick={getExcelDownload} title="Download Excel">
                                        <i className="icon-excel-outline" />
                                    </button>
                                    <span ref={() => checkPermission("help desk", tagRef)}>
                                        <button ref={tagRef} id='{"tabname": "helpdesk", "data": "request_type_user_mapping"}' className="sk-btn sk-btn-primary" title="Mapping" onClick={() => setShowPopup({
                                            show: true,
                                            type: "request"
                                        })}>
                                            <i className="icon-team_group-outline" />
                                        </button>
                                    </span>
                                </div>
                            }
                            <button className="sk-btn sk-btn-primary" onClick={() => { if (tab !== "chart") { setShowPopup({ show: true, type: "create" }); } else { setChart((prev) => ({ ...prev, visible: true })) } }}>
                                <i className="icon-add-outline" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-wrap gap-2 mb-2 px-3">
                    {[{ priority_name: "All" }, ...(options?.priorityOption || [])]?.map((value, index) => {
                        const isSelected = filters?.priority?.priority_name === value?.priority_name;
                        const priorityCount = data?.priorityCount?.find(t => t?.priority_name?.toLowerCase() === value?.priority_name?.toLowerCase());
                        return (
                            <div onClick={(e) => {
                                setFilters(prev => ({ ...prev, priority: value }));
                            }} className={`border rounded-pill c-pointer fw-semibold align-self-center ${isSelected ? "bg-dark" : ""}`} style={{ padding: "5px 10px " }} key={index}><span className={`${isSelected ? "text-light" : ""}`} >{value?.priority_name}:</span> <span className='px-2' style={{ background: "#E1E6EA", borderRadius: "20px", }}>{priorityCount?.ticket_count || 0}</span></div>
                        );
                    })}
                </div>
                <div className="d-flex gap-2 mb-2 flex-wrap px-2">
                    {statuses?.map(value => {
                        const data = statusCount?.find(t => t?.status_name?.toLowerCase() === value?.key?.toLowerCase());
                        return (
                            <div key={value.key}
                                className={`sk-card-container flex-fill ${theme} ${filters?.status === data?.status_id ? "universal-helpdesk-card-active" : ""}`}
                                style={{ minWidth: 140, cursor: 'pointer' }}
                                onClick={() => { setFilters((prev) => ({ ...prev, status: data?.status_id })); getRequestData(false, data?.status_id) }}>
                                <div className="sk-card-header">
                                    <div>
                                        <div className="sk-card-sub-text">{value?.key}</div>
                                        <div className="sk-card-name">{data?.ticket_counts || 0}</div>
                                    </div>
                                    <div className="sk-card-action-btn" style={{ background: value?.badge, color: value?.iconColor }}>
                                        <FontAwesomeIcon icon={value?.icon} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {tab !== "chart" ?
                    <div>
                        {
                            loader ? <SkeletonDataTable numSkeletons={12} /> : <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 270px)", width: '100%' }}>
                                <AgGridReact
                                    rowData={data?.tickets}
                                    columnDefs={columnDefs}
                                    rowHeight={40}
                                    headerHeight={30}
                                />
                            </div>
                        }
                        {pagination?.show && (
                            <Pagination
                                totalRecords={pagination?.totalRecords}
                                totalPages={pagination?.totalPages}
                                currentPage={pagination?.currentPage}
                                displayPageOutOfTotal={pagination?.displayPageOutOfTotal}
                                onPageChange={(e) => setPagination((prev) => ({ ...prev, currentPage: e }))}
                            />
                        )}
                    </div> :
                    <div className="mt-4 px-2">
                        <UniHelpdeskCharts chart={chart} setChart={setChart} columns={columnDefs} rowData={data?.tickets}/>
                    </div>
                }
                <Dialog header="Media" visible={selectedData?.show} className='modal-small' draggable={false} modal onHide={() => setSelectedData({ show: false, data: [] })}>
                    <CommonImage type="view" selectedImages={selectedData?.data} />
                </Dialog>
                {showPopup?.show && showPopup?.type === "create" && <CreateTicket
                    visible={showPopup?.show && showPopup?.type === "create"}
                    onHide={() => {
                        setShowPopup({
                            show: false,
                            type: ""
                        }); setEditData()
                    }}
                    selectedData={editData}
                    options={options}
                    getRequestData={() => getRequestData()}
                    filters={filters}
                />}
                {
                    showPopup?.show && showPopup?.type === "request" && <RequestTypeMapping
                        visible={showPopup?.show && showPopup?.type === "request"}
                        onHide={() => {
                            setShowPopup({
                                show: false,
                                type: ""
                            }); setEditData()
                        }}
                        options={options}
                    />
                }
            </div>
            <Dialog header="Ticket History" visible={historyPopup?.show} className='modal-small' draggable={false} modal onHide={() => setHistoryPopup({ show: false, data: [] })}>
                <div>
                    {
                        historyPopup?.data?.map((value, index) => {
                            return <div key={index} className="row m-2 p-2" style={{ background: "#e3e3e3" }}>
                                <div className="col-md-6 col-12">
                                    <p className="my-2"><strong>Updated Time:</strong> {dateConvert(value?.status_change_datetime, 'date-time-month')}</p>
                                    <p><strong>Priority:</strong> {value?.priority_name}</p>

                                </div>
                                <div className="col-md-6 col-12">
                                    <p className="my-2"><strong>Updated By:</strong> {value?.action_by_name}</p>
                                    <p><strong>Status:</strong> {value?.status_name}</p>
                                </div>
                                <div className="col-12">
                                    <p className="my-2"><span>  <strong>Summary: </strong><span>{value?.ticket_summary}</span></span></p>
                                    <p><strong>Remark: </strong><span>{value?.comments}</span></p>
                                </div>
                            </div>
                        })
                    }
                </div>
            </Dialog>
            <Dialog header={() => {
                return <div>
                    #{commentPopup?.data?.ticket_id} — {commentPopup?.data?.ticket_subject}
                    <p style={{ color: "gray", fontSize: "12px" }}>{commentPopup?.data?.request_type_name} &gt; {commentPopup?.data?.request_sub_type_name}  — Created: {dateConvert(commentPopup?.data?.created_datetime, "day-month-year")}</p>
                </div>
            }} visible={commentPopup?.show} draggable={false} className="modal-small" modal onHide={() => {
                const readComments = _.filter(commentPopup?.comments, comment => comment.is_read === null || comment.is_read === false);
                readComments?.length > 0 && updateTicketCommentsRead(_.uniq(_.pluck(readComments, 'ticket_comment_id')))
                setCommentPopup({ show: false, input: "", comments: [] })
            }}>
                <div style={{ height: '320px', overflowY: 'auto', marginBottom: '1rem' }} ref={chatRef}>
                    <div className="system-note" style={{ width: "fit-content" }}>
                        Ticket created by user {commentPopup?.data?.user_display_name} {dateConvert(commentPopup?.data?.created_datetime, "date-time-months")}
                    </div>
                    {commentPopup?.comments?.map((c, index) => {
                        const isCurrentUser = c.commented_by === options?.user?.user_code;
                        return (
                            <div
                                key={index}
                                className={`d-flex my-2 gap-2 align-items-end ${isCurrentUser ? 'justify-content-start ' : ''}`}
                                style={{ flexDirection: isCurrentUser ? 'row-reverse' : 'row', }}
                            >
                                <img
                                    src={c?.image_url}
                                    width={30}
                                    height={30}
                                    className="rounded-circle"
                                    alt="avatar"
                                />
                                <div className="p-2 rounded" style={{ textAlign: isCurrentUser ? 'right' : 'left', background: isCurrentUser ? '#e0f1ff' : '#f1f1f1', boxShadow: " 0 2px 3px rgba(0, 0, 3, .1)", maxWidth: "74%" }}>
                                    <div className={`d-flex text-secondary gap-1 ${isCurrentUser ? 'justify-content-end ' : 'justify-content-start'}`} style={{ fontSize: "12px" }}>
                                        <strong > {c.commented_user_name} •</strong>
                                        <span>{dateConvert(c.commented_date, "date-time-months")}</span>
                                    </div>
                                    <p className={`msg-text ${!c.is_read && !isCurrentUser && "bold"}`}>{c.comments}</p>
                                </div>

                            </div>
                        );
                    })}
                </div>
                <textarea
                    value={commentPopup?.inputs}
                    onChange={(e) => setCommentPopup((prev) => ({ ...prev, inputs: e.target.value }))}
                    placeholder="Write your comment... (Press Enter to send)"
                    className=" w100 rounded"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            saveComment();
                        }
                    }}></textarea>

                <div class="d-flex justify-content-between">
                    <div class="d-flex gap-2 align-items-center">
                        <div class="small-muted">You are commenting as <strong>{options?.user?.user_display_name}</strong></div>
                    </div>

                    <div class="d-flex gap-2">
                        <button onClick={saveComment} class="sk-btn sk-btn-primary" id="sendBtn"><i className="icon-paper-plane" /> Send</button>
                    </div>
                </div>

            </Dialog>
            <Dialog draggable={false} visible={showTimesheet} onHide={() => { setFilters({ hoveredRange: [new DateObject(), new DateObject()] }); setShowTimesheet(false); }}
                header={`${calendarDate?.toLocaleString('en-GB')?.split(",")[0]?.split("/")?.join("-")}  [ Hours: ${[calendarDate?.toLocaleString("en-GB")?.split(",")[0]?.split("/")?.reverse()?.join("-")]?.loginfo || 0}h]`} className='wc-timesheet-dialog p-0' modal style={{ width: "95vw", height: "90vh" }} resizable={false}>
                <Logwork isMyBucket={true} handleDateSelected={handleDateSelected} onSave={() => getTimesheetCalendarSummary()}
                    closePopup={() => { setShowTimesheet(false); }} date={calendarDate} timesheetData={tableData} setFilterValue={setFilterValue} filterValue={filterValue} />
            </Dialog>
        </div>
    );
}

export default UniversalHelpdesk;
